<template>
  <form :ref="subscribeForm" id="subscribeForm" class="is-relative" v-on:submit.prevent="validateBeforeSubmit" method="post" novalidate>
    <!-- input Email field -->
    <div class="field">
      <div class="control has-icons-left has-icons-right">
        <input class="input is-medium is-rounded"
               :ref="emailInput"
               v-on:focus="clearErrorsOnFocusEmpty"
               v-on:blur="toogleOverlayOpacity"
               v-on:keyup="clearErrors"
               v-model="email"
               name="email"
               type="email"
               autocomplete="off"
               placeholder="Email Address"
               v-validate="'required|email'"
               v-bind:class="errors.has('email') ? 'is-danger' : 'is-giada-green'">
        <span class="icon is-normal is-left">
          <i class="fas fa-envelope"></i>
        </span>
        <span class="icon is-normal is-right has-text-danger" v-if="errors.has('email')">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <!-- error field -->
      <span class="help is-danger is-size-6 has-text-left"  v-if="errors.has('email')">
        {{ errors.first('email') }}
      </span>

    </div>
    <!-- button field -->
    <div class="field">
      <div class="control">
        <button class="button is-medium is-centered is-fullwidth is-outlined is-rounded is-giada-green">{{button_text}}</button>
      </div>
    </div>

  </form>
</template>

<script>
import {bus} from '../../main'
import SuccessSubmission from './SuccessSubmission'

export default {
  name: 'LandingForm',
  data: function () {
    return {
      subscribeForm: 'subscribeForm',
      emailInput: 'emailInput',
      button_text: 'Let me in!',
      email: '',
      isFocused: false,
      inviteCode: null // ,
      // ipGeo: null
    }
  },
  methods: {
    validateBeforeSubmit: function (event) {
      console.log(event)
      let vm = this
      this.$validator.validateAll().then(result => {
        if (result) {
          const loading = this.$loading.open()
          // this.$http.post('http://localhost:5000/landing-page-ver1/us-central1/giadaFunc/subscribe',
          this.$http.post('https://us-central1-landing-page-ver1.cloudfunctions.net/giadaFunc/subscribe',
            {
              email: this.email,
              inviteCode: this.inviteCode
            },
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            }
          ).then((res) => {
            loading.close()
            this.gtmFormTrack()
            this.toogleThanksModal(res.body.token, res.body.counter)
          }, res => {
            loading.close()
            if (res.body.errors && res.status === 422) {
              Object.keys(res.body.errors).forEach(key => {
                vm.$validator.errors.add(res.body.errors[key].param, vm.$validator.dictionary.getMessage('en', res.body.errors[key].msg.type, [vm.$validator.dictionary.getAttribute('en', res.body.errors[key].param), [res.body.errors[key].msg.extra]]))
              })
            } else {
              let errorCode = res.status === 0 ? 403 : res.status
              this.$router.push({name: 'ErrorPage', params: {'0': '/' + String(errorCode), status: String(errorCode)}})
            }
          })
        }
      })
    },
    // getIp: function () {
    //  this.$http.get('http://ip-api.com/json/?fields=262143').then(response => {
    //    this.ipGeo = response.data
    //  }, err => {
    //    console.log('Houston we have a Problem GET!!!', err)
    //  })
    // },
    gtmFormTrack: function () {
      this.$gtm.trackEvent({
        event: 'newSubscriber',
        category: 'Form Submission',
        action: 'submit',
        label: 'Landing page Subscribe Form',
        // ipGeo: this.ipGeo,
        dateEvent: new Date(Date.now()),
        value: this.email
      })
    },
    toogleOverlayOpacity: function () {
      this.isFocused = !this.isFocused
      bus.$emit('overlayOpacityChanged', this.isFocused)
    },
    toogleThanksModal: function (token, counter) {
      this.$modal.open({
        parent: this,
        component: SuccessSubmission,
        onCancel: () => this.resetForm(),
        props: {
          sender: this.email,
          token: token,
          counter: counter
        }
      })
    },
    resetForm: function () {
      this.$refs.subscribeForm.reset()
      this.clearErrors(this.$refs.emailInput)
      this.email = ''
      this.$router.replace('/')
    },
    clearErrors: function (item) {
      const field = this.$validator.fields.find(item)
      field.reset()
      return this.$validator.errors.remove(field.name, field.scope)
    },
    clearErrorsOnFocusEmpty: function (event) {
      this.toogleOverlayOpacity()
      if (event.target.value === '') {
        this.clearErrors(event.target)
      }
    },
    getQueryParameter: function () {
      if (this.$route.query.hasOwnProperty('invite')) {
        this.inviteCode = this.$route.query['invite']
      }
    }
  },
  mounted () {
    // this.getIp()
    this.getQueryParameter()
  }
}
</script>

<style scoped>
  .is-relative {
    display: block;
    position: relative;
    z-index: 2;
  }

</style>



// WEBPACK FOOTER //
// src/components/landingPage/LandingForm.vue